<div id="reports-form">
  <h2 mat-dialog-title class="btn-main">{{ title }}</h2>
  <mat-dialog-content>
    <div>
      <div id="report-basic">
        <div id="report-name-holder">
          <div>
            <label for="report-name">Report Name:</label>
            <input id="report-name" placeholder="Enter a name/title for your report here..." name="name" [value]="settings.name" (keyup)="updateSetting($event.target)" [tabindex]="editMode ? -1 : 0" [attr.enabled]="!editMode">
          </div>
          <span id="name-error" *ngIf="nameError">Name Already in use...</span>
        </div>
        <div *ngIf="settings.level === 4" id="reports-perm">
          <fieldset>
            <div>
              <label for="start-date">Initial date/time:</label>
              <input name="time-0" type="date" [value]="settings.times[0]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
              <input name="time-1" type="time" [value]="settings.times[1]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
            </div>
            <div>
              <label for="interval">Interval:</label>
              <select id="interval" name="time-2" [value]="settings.times[2]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                <option value="1">1 Day</option>
                <option value="7">7 Days</option>
                <option value="14">14 Days</option>
                <option value="30">30 Days</option>
              </select>
            </div>
          </fieldset>
        </div>
        <div *ngIf="settings.level !== 4">
          <div id="report-options">
            <ng-container id="report-type" *ngTemplateOutlet="radioOptions; context: { $implicit: levelOptions }">
            </ng-container>
            <fieldset id="interval">
              <legend>Interval:</legend>
              <ng-container id="report-unit-type" *ngTemplateOutlet="radioOptions; context: { $implicit: unitTypeOptions }">
              </ng-container>
              <div>
                <fieldset id="unit-amount" *ngIf="settings.unitType !== 5">
                  <span>Unit Amount:</span>
                  <input *ngIf="settings.unitType !== 3" name="unitAmount" type="number" min="1" [max]="settings.unitType === 4 ? 31 : 9999" [value]="settings.unitAmount" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                  <select *ngIf="settings.unitType === 3" name="unitAmount" [value]="settings.unitAmount" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)" >
                    <option value="0">Sunday</option>
                    <option value="1">Monday</option>
                    <option value="2">Tuesday</option>
                    <option value="3">Wednesday</option>
                    <option value="4">Thursday</option>
                    <option value="5">Friday</option>
                    <option value="6">Saturday</option>
                  </select>
                </fieldset>
                <fieldset id="tod">
                  <span>Time of Day:</span>
                  <input *ngIf="settings.unitType !== 5" name="timeOfDay" type="time" [value]="settings.timeOfDay" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                  <div *ngIf="settings.unitType === 5">
                    <input name="time-0" type="time" [value]="settings.times[0]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                    <input name="time-1" type="time" [value]="settings.times[1]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                    <input name="time-2" type="time" [value]="settings.times[2]" (keyup)="updateSetting($event.target)" (change)="updateSetting($event.target)">
                  </div>
                </fieldset>
              </div>
            </fieldset>
          </div>
          <fieldset id="alert-filters">
            <legend>Alert Filters:</legend>
            <fieldset *ngFor="let af of alertFilters">
              <legend>{{af.title}}:</legend>
              <div>
                <span class="btn-main" *ngFor="let event of af.events" [attr.selected]="settings.filters.includes(event)" (click)="toggleSelected($event, true)">{{event}}</span>
              </div>
            </fieldset>
          </fieldset>
        </div>
        <div id="cus-loc">
          <div *ngIf="[0, 3].includes(settings.level)">
            <ng-container id="customer-selection" *ngTemplateOutlet="selectorOptions; context: { $implicit: {title: 'Customers', options: customers }}">
            </ng-container>
          </div>
          <div *ngIf="[1, 3].includes(settings.level)">
            <ng-container id="location-selection" *ngTemplateOutlet="selectorOptions; context: { $implicit: {title: 'Locations', options: locations }}">
            </ng-container>
          </div>
          <ng-container id="email-selection" *ngTemplateOutlet="selectorOptions; context: { $implicit: {title: 'Recipients', options: recipients }}">
          </ng-container>
        </div>
      </div>
    </div>
    <div class="report-form-btns">
      <button id="cancel-report" mat-dialog-close>Cancel</button>
      <button id="save-report" (click)="submit()" [attr.enabled]="submitEnabled">Save</button>
    </div>
  </mat-dialog-content>
</div>

<ng-template id="radio" #radioOptions let-comp>
  <fieldset class="radio-element">
    <legend>{{comp.title}}</legend>
    <div>
      <div class="radio-opt" *ngFor="let opt of comp.options; let i = index">
        <input class="btn-main" type="radio" [id]="opt.id" [value]="opt.value" [name]="comp.key" [checked]="i === settings[comp.key]" (change)="updateSetting(radioSelected)" #radioSelected>
        <label class="btn-main" [for]="opt.id">{{opt.label}}</label>
      </div>
    </div>
  </fieldset>
</ng-template>

<ng-template id="selector" #selectorOptions let-comp>
  <fieldset class="selector-element">
    <legend>{{initComp(comp)}}</legend>
    <div class="sel-add-opts">
      <div class="sel-filter">
        <label for="sel-filter-input">Filter:</label>
        <input id="sel-filter-input" placeholder="Start typing to filter..." #filter (keyup)="filterOptions(filter, comp, $event)" (paste)="filterOptions(filter, comp, $event)">
        <div id="sel-add" class="fa-solid fa-circle-plus" *ngIf="comp.title === 'Recipients'" [attr.enabled]="comp.valid" (click)="addRecipient(comp, filter)"></div>
      </div>
      <div class="sel-opts">
        <div #availableOpts>
          <span class="btn-main" *ngFor="let opt of comp.available" (click)="toggleSelected($event)" [attr.data]="opt.id">{{opt.name}}</span>
        </div>
      </div>
    </div>
    <div class="sel-btns">
      <div class="fa-solid fa-caret-left btn-main" (click)="moveSelection(selectedOpts, comp, 'rem')"></div>
      <div class="fa-solid fa-caret-right btn-main" (click)="moveSelection(availableOpts, comp, 'add')"></div>
    </div>
    <div class="sel-rem-opts">
      <div class="sel-opts">
        <div #selectedOpts>
          <span class="btn-main" *ngFor="let opt of comp.selected" (click)="toggleSelected($event)" [attr.data]="opt.id">{{opt.name}}</span>
        </div>
      </div>
    </div>
  </fieldset>
</ng-template>